export default __webpack_public_path__ + "static/project-slide-5-1640-765-a9f4eaf7cd10cfd946eef4b0ccd62ed4.webp";